export default "/images/pergamumAlto.svg?d94f48f91821042ced62414a34943f43";